import { Link } from 'gatsby';
import MotionArticles from 'components/Motion_Detection/IntroMotion';
import NavButtons from 'components/Motion_Detection/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  MotionArticles,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};